import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import {
  ReactFlow,
  ReactFlowProvider,
  applyNodeChanges,
  Background,
  BackgroundVariant,
  Position
} from '@xyflow/react';
import Connections from "../../editor/connections";
import { BhFlowNode, BhFlowTitle, BhFlowSubtitle } from '../../flowkit/flowNode';
import BhHandle from '../../flowkit/handle';
import { FlowInGlyph, FlowOutGlyph, DataGlyph, ProviderGlyph } from '../../flowkit/glyphs';
import BhFlowEdge, { BhEdgeMarkers } from '../../flowkit/flowEdge';
import Components from '../../controls/common/components';
import "./preview.css";

const components = new Components();

export function ProcessorNode({ data, isConnectable, selected }) {
  const handles = (
    <>
      <BhHandle mode="fixed" type="target" position={Position.Top} id="flow_input" style={{ left: 15 }}
        isConnectable glyph={<FlowInGlyph />} />
      <BhHandle mode="fixed" type="source" position={Position.Bottom} id="flow_output" style={{ left: 15 }}
        isConnectable glyph={<FlowOutGlyph />} />
      <BhHandle mode="fixed" type="source" position={Position.Top} id="data_input" style={{ right: 8, left: 'auto' }}
        isConnectable glyph={<DataGlyph />} />
      <BhHandle mode="fixed" type="source" position={Position.Bottom} id="data_output"
        style={{ right: 8, left: 'auto' }} isConnectable glyph={<DataGlyph />} />
      <BhHandle mode="fixed" type="source" position={Position.Left} id="provider_input"
        isConnectable glyph={<ProviderGlyph />} />
      <BhHandle mode="fixed" type="target" position={Position.Right} id="provider_reference"
        isConnectable glyph={<ProviderGlyph />} />
      <BhHandle mode="fixed" type="target" position={Position.Left} id="data_reference"
        isConnectable glyph={<ProviderGlyph />} />
    </>
  );
  return (
    <BhFlowNode selected={selected} icon={components.getComponentIcon(data.processor.type)} attachments={handles}>
      <BhFlowTitle>{data.processor.name}</BhFlowTitle>
      <BhFlowSubtitle tone="pink">{data.processor.type}</BhFlowSubtitle>
    </BhFlowNode>
  );
}

export default class Preview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nodes: [],
      edges: []
    };

    this.nodeTypes = {
      processorNode: ProcessorNode,
    };

    this.edgeTypes = {
      bhEdge: BhFlowEdge,
    };
  }

  componentDidMount() {
    this.parseDefinition();
  }

  componentDidUpdate(prevProps) {
    if ( null != this.props.definition && null == prevProps.definition ) {
      this.parseDefinition();
    }

    if ( this.props.currentProcessorId !== prevProps.currentProcessorId ) {
      let nodes = [];
      for ( const node of this.state.nodes ) {
        node.selected = node.data.processor["id"] == this.props.currentProcessorId;
        nodes.push({...node});
      }
      this.setState({ nodes: nodes });
    }
  }

  parseDefinition() {
    if ( null == this.props.definition ) {
      return;
    }

    let nodes = [];
    let edges = [];

    for ( const processor of this.props.definition["components"] ) {
      let node = {
        type: "processorNode",
        id: processor["id"],
        position: processor["position"],
        data: {
          processor: processor
        },
        selected: processor["id"] == this.props.currentProcessorId
      };
      nodes.push(node);
    }

    for ( const connection of this.props.definition["connections"] ) {
      let edge = {
        type: "bhEdge",
        id: connection["id"],
        source: connection["source_id"],
        sourceHandle: connection["source_port"],
        target: connection["target_id"],
        targetHandle: connection["target_port"],
        label: connection["route"]
      };

      // Flow connections are rendered as animated
      if ( Connections.isFlowConnection(edge) ) {
        edge.animated = true;
      }

      edges.push(edge);
    }

    this.setState({
      nodes: nodes,
      edges: edges
    });
  }

  render() {
    return (
      <>
        {( null == this.props.execution || this.props.definitionProgress.progress ) &&
          <Alert variant="primary">
            Loading execution details...
          </Alert>
        }
        {this.props.definitionProgress.error &&
          <Alert variant="warning">
            Failed to fetch definition associated with this execution. Does it still exist?
          </Alert>
        }
        {null != this.props.definition &&
          <div className="workflow-preview workflow-preview-surface">
            <ReactFlowProvider>
              <ReactFlow
                nodeTypes={this.nodeTypes}
                edgeTypes={this.edgeTypes}
                nodes={this.state.nodes}
                edges={this.state.edges}
                elementsSelectable={false}
                fitView
                attributionPosition="bottom-right"
                minZoom={0.1}
                maxZoom={2}
              >
                <BhEdgeMarkers />
                <Background id="preview-background" variant={BackgroundVariant.Dots} gap={12} size={1} />
              </ReactFlow>
            </ReactFlowProvider>
          </div>
        }
      </>
    );
  }
}
